import React, {Fragment} from 'react'

import {useState} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useFirebase, useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import {Label, Button, Input, Menu, Icon} from 'semantic-ui-react'
import {env} from '../../constants/Environment';
const moment = require('moment')

function Eventlist(props){
    const [activeItem, setActiveItem] = useState(null);

    useFirestoreConnect([
        { collection: 'environments/' + env + '/programs/0/oe', where: [
            'plus-id', '==', parseInt(props.plusId)
        ]}
    ])

    const events = useSelector(({ firestore: { data } }) => data['environments/' + env + '/programs/0/oe'])

    return (
        <Menu fluid vertical>
            {
                (typeof events !== 'undefined' && events !== null)?
                    Object.values(events).map((event, idx) => {
                        if(parseInt(event['plus-id']) === parseInt(props.plusId))
                            return (
                                <Menu.Item key={idx} active={(activeItem !== null && activeItem === event.uid)?true:false} onClick={(e) => {
                                    setActiveItem(event.uid);
                                    props.onSelectEvent(event)
                                }}>
                                    <small>{moment.unix(event['active-to-utc'].seconds).format('dddd, D. MMMM YYYY [um] HH:mm [Uhr]')}</small>
                                    <div>
                                    {
                                        event.name
                                    }
                                    </div>
                                </Menu.Item>
                            )
                        
                        return null;
                    })
                :null
            }
        </Menu>
    )
}

const Marketlist = (props) => {
    const [activeItem, setActiveItem] = useState(null);

    return (
        <Menu fluid vertical>
        {

            Object.keys(props.event.markets).map((marketKey) => {
                let market = props.event.markets[marketKey];

                return (
                    <Menu.Item key={marketKey} active={(activeItem !== null && activeItem === marketKey)?true:false} onClick={(e) => {
                        setActiveItem(marketKey);
                        props.onSelectMarket(props.event, market);
                    }}>
                        <small></small>
                        <div>
                        {
                            market.name
                        }
                        </div>
                    </Menu.Item>
                )
            })
        }
        </Menu>
    )
}

const Eventdetails = (props) => {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'flex-start'
        }}>
            <Button circular icon="chevron left" color="teal" onClick={props.onBackClick} />
            <div style={{
                flexGrow: 1,
                marginLeft: '1em'
            }}>
                <div style={{
                    fontSize: '0.9em',
                    color: '#777777',
                    borderBottom: '1px solid #EEEEEE',
                    paddingBottom: '10px',
                    marginBottom: '10px'
                    
                }}>
                    {props.event.sport.name} › {props.event.category.name} › {props.event.tournament.name}
                </div>
                <div style={{
                    fontSize: '0.9em',
                    color: '#777777'
                }}>
                    {moment.unix(props.event['active-to-utc'].seconds).format('dddd, D. MMMM YYYY [um] HH:mm [Uhr]')}
                </div>

                {props.event.name}
            </div>
        </div>
    )
}

export default function EventPicker(props){
    const firestore = useFirestore();

    const [plusId, setPlusId] = useState('');
    const [event, setEvent] = useState(null);

    //const sports = useSelector(({ firestore: { data } }) => data['environments/dev/programs/0/sport'])

    const events = useSelector(({ firestore: { data } }) => data['environments/' + env + '/programs/0/oe'])

    return (
        <div>
            {
                (event === null)?
                    <Fragment>
                        <Input fluid placeholder="Plus-Nummer..." value={plusId} onChange={(e, {value}) => setPlusId(value)} icon={
                                <Icon name='search' disabled={(plusId.length > 0)?false:true} inverted={(plusId.length > 0)?true:false} circular link={(plusId.length > 0)?true:false} onClick={(e) => searchEvent(e)} />
                            } />
                        {
                            (plusId.length > 0)?
                                    <Eventlist plusId={plusId} onSelectEvent={(event) => {
                                        if(typeof props.pickMarkets !== 'undefined' && props.pickMarkets)
                                            setEvent(event);
                                        else if(typeof props.onSelectEvent === 'function')
                                            props.onSelectEvent(event);
                                    }} />
                            :null
                        }
                    </Fragment>
                :
                    <Eventdetails event={event} onBackClick={(e) => {
                        setEvent(null);
                    }} />
            }

            {
                (typeof sports !== 'undefined' && sports !== null)?
                    <Menu fluid vertical>
                    {
                        Object.values(sports).map((sport) => {
                            return (
                                <Menu.Item as='a'>
                                    {sport.name} <Label circular color={(sport['event-count'].active > 0)?'green':'grey'}>{sport['event-count'].active}</Label>
                                </Menu.Item>
                            )
                        })
                    }
                    </Menu>
                :null
            }

            {
                (event !== null && typeof props.pickMarkets !== 'undefined' && props.pickMarkets)?
                    <Marketlist event={event} onSelectMarket={(event, market) => {
                        if(typeof props.onSelectMarket === 'function')
                            props.onSelectMarket(event, market);
                    }} />
                :null
            }
        </div>
    )
}